import axios from 'axios'
import { ManagerApprovalRulesResponse } from 'src/models/organizations.models'
import { getResponseData } from 'src/queries/network.utils'
import { getRequestConfig, RequestConfig } from 'src/queries/requestConfig'

export const getManagerReviewRules =
  async (): Promise<ManagerApprovalRulesResponse> =>
    getResponseData(
      axios.get<ManagerApprovalRulesResponse>(
        `/expensereview/expensemanagementsettings`,
        getRequestConfig(RequestConfig.Default),
      ),
    )
